export default __webpack_public_path__ + "static/media/wallets.6b577d08.png";